import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { Spin } from "antd";
import { post } from "../../../helpers/api_helper";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  POST_EmailTemplatesContentSave,
  POST_GetInstanceTypeList,
} from "../../../helpers/url_helper";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";

const EmailTemplatesEdit = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [instanceTypeOptions, setInstanceTypeOptions] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [htmlContent, setHtmlContent] = useState("");

  const validationSchema = Yup.object().shape({
    InstanceTypeID: Yup.string()
      .trim()
      .required("Instance Type is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Instance: "",
      SendTo: "",
      Subject: "",
      AdditionalRecipientEmailID: "",
      EmailType: "",
      InstanceTypeID: "",
      HTMLParameter: "",
      HTMLFilePath: "",
      HTMLData: "",
      SendEmailConfigurationIDEncrypted: "",
      SubjectParameter: "",
      HTMLParameterPlaceholder: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { InstanceTypeID, SubjectParameter },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    const placeholderRegex = /{{\s*[\w]+\s*}}|\[\s*[\w]+\s*\]/g;

    // Extract placeholders from HTMLParameter (e.g., {{RecipientName}}, {{InwardNo}})
    const htmlParameterPlaceholders =
      values?.HTMLParameter.match(/{{\s*[\w]+\s*}}/g) || [];

    const subjectParameterPlaceholders = values?.SubjectParameter
      ? values?.SubjectParameter.match(placeholderRegex) || []
      : [];

    // Check if all placeholders are present in the HTML content
    const missingPlaceholders = htmlParameterPlaceholders.filter(
      (placeholder) => {
        return !htmlContent.includes(placeholder);
      }
    );

    // Validate placeholders in Subject
    const missingInSubject = subjectParameterPlaceholders.filter(
      (placeholder) => {
        return !values.Subject.includes(placeholder);
      }
    );

    if (missingPlaceholders.length > 0) {
      errorMessage(
        `Validation Error: The following placeholders are missing in the HTML content: ${missingPlaceholders.join(
          ", "
        )}`
      );
      setIsLoading(false);
      return;
    }

    if (missingInSubject.length > 0) {
      errorMessage(
        `Validation Error: The following placeholders are missing in the Subject content: ${missingInSubject.join(
          ", "
        )}`
      );
      setIsLoading(false);
      return;
    }

    let payload = {
      ...values,
      HTMLContent: htmlContent, // The HTML content from CKEditor
      FileName: values.HTMLFilePath,
      InstanceTypeID: values?.InstanceTypeID,
      Subject: values?.Subject,
      SendEmailConfigurationIDEncrypted:
        values?.SendEmailConfigurationIDEncrypted,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    console.log("payload", payload);
    //setIsLoading(false);
    //return;

    post(POST_EmailTemplatesContentSave, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/dashboard");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    setIsLoading(false);
  };

  useEffect(() => {
    getEmailConfigurationList();
  }, []);

  const getEmailConfigurationList = async () => {
    setIsLoading(true);

    await post(POST_GetInstanceTypeList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setInstanceTypeOptions(
            response?.ListOfInstanceType?.filter(
              (x) => x.IsEmail == true && x.InstanceType != 12
            )?.map((item) => {
              const htmlParameter = item?.HTMLParameter ?? "";
              const htmlParameterPlaceholder =
                item?.HTMLParameterPlaceholder ?? "";

              const subjectParameter = item?.SubjectParameter ?? "";

              // Split by spaces and join with new lines
              const splitHtmlParameter = htmlParameter.split(" ").join("\n");
              const splitHtmlParameterPlaceholder = htmlParameterPlaceholder
                .split(".")
                .join(".\n");

              const splitSubjectParameter = subjectParameter
                .split(" ")
                .join("\n");

              return {
                label: item?.Instance,
                value: item?.InstanceType,
                SendTo: item?.SendTo,
                Subject: item?.Subject,
                AdditionalRecipientEmailID: item?.AdditionalRecipientEmailID,
                EmailType: item?.EmailType,
                HTMLData: item?.HTMLData,
                HTMLFilePath: item?.HTMLFilePath,
                SendEmailConfigurationIDEncrypted:
                  item?.SendEmailConfigurationIDEncrypted,
                HTMLParameter: splitHtmlParameter, // Set the transformed value
                HTMLParameterPlaceholder: splitHtmlParameterPlaceholder,
                SubjectParameter: splitSubjectParameter,
              };
            })
          );

          // setInstanceTypeOptions(
          //   response?.ListOfInstanceType?.filter(
          //     (x) =>
          //       x.IsEmail == true &&
          //       x.InstanceType != 12 &&
          //       x.InstanceType != 13
          //   )?.map((item) => ({
          //     label: item?.Instance,
          //     value: item?.InstanceType,
          //     SendTo: item?.SendTo,
          //     Subject: item?.Subject,
          //     AdditionalRecipientEmailID: item?.AdditionalRecipientEmailID,
          //     EmailType: item?.EmailType,
          //     HTMLData: item?.HTMLData,
          //     HTMLFilePath: item?.HTMLFilePath,
          //     HTMLParameter:
          //       "{{RecipientName}} {{DispatchedCustomerNameandDetails}} {{InwardNo}}",
          //   }))
          // );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // Fetch the HTML content when the selected file changes
  useEffect(() => {
    if (selectedFile) {
      setHtmlContent(selectedFile);
    }
  }, [selectedFile]);

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Email Templates</h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={2}>
                      <Field
                        label="Instance Type"
                        name="InstanceTypeID"
                        placeholder={"Select Instance Type"}
                        component={CustomSelect}
                        options={instanceTypeOptions}
                        required
                        autoFocus
                        onChange={(e) => {
                          formik.setFieldValue(
                            "InstanceTypeID",
                            e?.value ?? ""
                          );
                          formik.setFieldValue("Instance", e?.label ?? "");
                          formik.setFieldValue("SendTo", e?.SendTo ?? "");
                          formik.setFieldValue("Subject", e?.Subject ?? "");

                          formik.setFieldValue(
                            "AdditionalRecipientEmailID",
                            e?.AdditionalRecipientEmailID ?? ""
                          );
                          formik.setFieldValue(
                            "HTMLParameter",
                            e?.HTMLParameter ?? ""
                          );
                          formik.setFieldValue(
                            "HTMLParameterPlaceholder",
                            e?.HTMLParameterPlaceholder ?? ""
                          );

                          formik.setFieldValue(
                            "SubjectParameter",
                            e?.SubjectParameter ?? ""
                          );
                          formik.setFieldValue("EmailType", e?.EmailType ?? "");
                          formik.setFieldValue(
                            "HTMLFilePath",
                            e?.HTMLFilePath ?? ""
                          );
                          formik.setFieldValue("HTMLData", e?.HTMLData ?? "");
                          formik.setFieldValue(
                            "SendEmailConfigurationIDEncrypted",
                            e?.SendEmailConfigurationIDEncrypted ?? ""
                          );
                          setSelectedFile(e?.HTMLData ?? "");
                        }}
                      />
                    </Col>
                    {InstanceTypeID ? (
                      <>
                        <Col lg={2}>
                          <Field
                            label="Send To"
                            name="SendTo"
                            placeholder={"Send To"}
                            component={CustomInput}
                            disabled={true}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Email Type"
                            name="EmailType"
                            placeholder={"Email Type"}
                            component={CustomInput}
                            disabled={true}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Additional Recipient EmailID"
                            name="AdditionalRecipientEmailID"
                            placeholder={"Additional Recipient EmailID"}
                            component={CustomInput}
                            disabled={true}
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            label="Subject"
                            name="Subject"
                            placeholder={"Subject"}
                            component={CustomInput}
                          />
                        </Col>
                        {SubjectParameter ? (
                          <Col lg={2}>
                            <Field
                              label="Subject Fields"
                              name="SubjectParameter"
                              // component={CustomInput}
                              component={CustomTextArea}
                              rows={2}
                              disabled={true}
                            />
                          </Col>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </Row>
                  {InstanceTypeID ? (
                    <>
                      <hr className="mt-1 mb-1"></hr>

                      <Row>
                        <Col lg={8}>
                          <div className="card-body custom-ekeditor">
                            <CKEditor
                              editor={ClassicEditor}
                              data={htmlContent} // Load HTML content into the editor
                              config={{
                                toolbar: [
                                  "bold",
                                  "italic",
                                  "link",
                                  "undo",
                                  "redo",
                                  "bulletedList", // Add bullet list
                                  "numberedList", // Add numbered list
                                  "indent", // Increase indent
                                  "outdent", // Decrease indent
                                  //"blockQuote", // Add block quote
                                ],
                                // allowedContent: true, // Allow all HTML content, including placeholders
                                // extraAllowedContent: "table tbody tr td th[*]", // Allow full table elements
                              }}
                              onReady={(editor) => {
                                // Custom key handling
                                editor.model.document.on("change:data", () => {
                                  const data = editor.getData();
                                  setHtmlContent(data);
                                });

                                // Handle Enter key
                                editor.keystrokes.set(
                                  "enter",
                                  (keyEvtData, cancel) => {
                                    // Allow default behavior to execute
                                    editor.execute("enter");
                                    cancel(); // Prevent default behavior to execute custom logic if needed
                                  }
                                );
                                editor.keystrokes.set(
                                  "shift+enter",
                                  (keyEvtData, cancel) => {
                                    //console.log("Shift + Enter pressed");
                                    cancel(); // Prevent default behavior
                                    editor.model.change((writer) => {
                                      const selection =
                                        editor.model.document.selection;
                                      const position =
                                        selection.getFirstPosition();
                                      writer.insertElement(
                                        "softBreak",
                                        position
                                      );
                                      writer.setSelection(
                                        position.getShiftedBy(1)
                                      );
                                    });
                                  }
                                );
                                // Set initial data when the editor is ready, if needed
                                if (htmlContent) {
                                  editor.setData(htmlContent);
                                }
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setHtmlContent(data); // Optionally, update content state
                              }}
                              onBlur={(event, editor) => {}}
                              onFocus={(event, editor) => {}}
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <Field
                            label="Placeholders"
                            name="HTMLParameterPlaceholder"
                            component={CustomTextArea}
                            rows={15}
                            disabled={true}
                          />
                          <label style={{ color: "red" }}>
                            {htmlContent
                              ? "Note : Only above listed fields can be used in Email Template. "
                              : ""}
                          </label>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="stickyBottomButtons">
                    <hr className="mt-1 mb-2"></hr>

                    <button
                      type="submit"
                      className="btn btn-primary btn-sm me-2"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </button>

                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        navigate(-1);
                      }}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </button>
                  </div>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default EmailTemplatesEdit;
